import { ChevronLeft } from "lucide-react";

/** 상세 → 목록 복귀 */
export const DsdReviewBackButton = ({ onBack }: { onBack: () => void }) => (
  <button
    type="button"
    onClick={onBack}
    className="flex shrink-0 items-center gap-1 border-b border-line-normal px-4 py-3 text-label-normal transition-colors hover:text-label-alternative"
  >
    <ChevronLeft className="size-4 shrink-0" />
    <span className="label-2-medium truncate">목록으로</span>
  </button>
);
